import React from "react";
import { Card, CardHeader, CardBody, CardTitle, Row, Col } from "reactstrap";
import CoreEngine from "../../core/CoreEngine";
import GarageForm from "./GarageForm";
import strings from "../../core/translate";

// Kept for the /branches/add and /branches/edit/:id links; the garages list
// itself opens the same form in a dialog.
export default class MerchantBranchAddUpdate extends CoreEngine {
  handleSaved = () => {
    const { selectedMerchant } = this.props.match.params;
    this.props.history.push(`/admin/merchant/${selectedMerchant}/branches`);
  };

  render() {
    const { selectedMerchant } = this.props.match.params;
    const garage = this.props.location.data;

    return (
      <div className="content english">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">
                  {garage && garage.id
                    ? `${strings.edit} ${strings.garage}`
                    : strings.add_garage}
                </CardTitle>
              </CardHeader>
              <CardBody>
                <GarageForm
                  garage={garage}
                  merchantId={selectedMerchant}
                  onSaved={this.handleSaved}
                  onCancel={this.handleSaved}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}
